import React from "react";

import { useSelector } from "react-redux";

// Importing Dashboards
import AdminDashboard from "./admin";
import EmployeeDashboard from "./employee";

// Import Utility
import { getDashBoardId } from "utils/authentication";

// Import Constants
import { SUPPORTED_DASHBOARDS } from "constants";

// Importing common components
import WarningAlert from "common/Alert";

const Dashboard = () => {
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  const allowedDashboard = {
    [SUPPORTED_DASHBOARDS.ADMIN]: <AdminDashboard />,
    [SUPPORTED_DASHBOARDS.EMPLOYEE]: <EmployeeDashboard />,
  };

  const dashboardId = getDashBoardId(loggedUserInfo);

  const IndexComponent = allowedDashboard[dashboardId];

  return IndexComponent ? (
    IndexComponent
  ) : (
    <WarningAlert
      type="info"
      message="<p>You have not been assigned any dashboard. If you are an administrator, you can assign the dashboard from the role management section.</p> <hr/> <p class='mb-0'>For additional help, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>"
    />
  );
};

export default Dashboard;
